import React from 'react';
import { getDisplayNameInitial, getUserDisplayName } from '../utils/nameUtils';

const Avatar = ({ 
  user, 
  size = 'w-12 h-12', 
  className = '',
  showBorder = false 
}) => {
  const displayName = getUserDisplayName(user);
  const initial = getDisplayNameInitial(displayName);
  const profileImageUrl = user?.profileImageUrl;

  const sizeClasses = {
    'w-8 h-8': 'text-xs',
    'w-10 h-10': 'text-sm',
    'w-12 h-12': 'text-base',
    'w-16 h-16': 'text-lg',
    'w-20 h-20': 'text-xl',
    'w-24 h-24': 'text-2xl'
  };

  const textSizeClass = sizeClasses[size] || 'text-base';

  return (
    <div className={`${size} rounded-full overflow-hidden bg-gradient-to-br from-cerulean to-primary-700 flex items-center justify-center text-white font-bold shadow-sm flex-shrink-0 ${className} ${showBorder ? 'ring-2 ring-white' : ''}`}>
      {profileImageUrl ? (
        <img 
          src={profileImageUrl}
          alt={displayName}
          className="w-full h-full object-cover"
          onError={(e) => {
            // If image fails to load, show initial instead
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div 
        className={`w-full h-full flex items-center justify-center ${textSizeClass}`}
        style={{ display: profileImageUrl ? 'none' : 'flex' }}
      >
        {initial}
      </div>
    </div>
  );
};

export default Avatar;
